@for (purpose of purposes; track purpose) {
  <div class="purpose">
    <strong>{{ 'tracking.trips.' + purpose | translate }}</strong>
    @for (rate of of(purpose); track rate.id) {
      <div class="rate-row">
        @if (editing?.id === rate.id) {
          <input nbInput fieldSize="small" type="text" inputmode="decimal" [(ngModel)]="editing.rate" [placeholder]="'reimbursementrate.rate' | translate">
          <input nbInput fieldSize="small" type="date" [(ngModel)]="editing.starts_on">
          <button nbButton ghost size="tiny" status="success" [disabled]="busy || !valid(editing)" (click)="save(editing)">{{ 'save' | translate }}</button>
          <button nbButton ghost size="tiny" (click)="editing = null">{{ 'cancel' | translate }}</button>
        } @else {
          <span>{{ 'reimbursementrate.perkm' | translate:{value: (rate.rate | number:'1.2-4':lang)} }}</span>
          <span>{{ 'reimbursementrate.from' | translate:{value: (rate.starts_on | localedate:'D MMMM YYYY')} }}</span>
          <button nbButton ghost size="tiny" (click)="edit(rate)">{{ 'edit' | translate }}</button>
          <button nbButton ghost size="tiny" status="danger" [disabled]="busy" (click)="remove(rate)">{{ 'delete' | translate }}</button>
        }
        @if (rate.warning) {
          <span class="warning">{{ 'reimbursementrate.' + rate.warning.code | translate:{max: (rate.warning.rate | number:'1.2-4':lang), year: rate.warning.year, source: rate.warning.source} }}</span>
        }
      </div>
    } @empty {
      <p class="hint">{{ 'reimbursementrate.none' | translate }}</p>
    }
  </div>
}
<div class="rate-row purpose">
  <nb-select size="small" [(selected)]="draft.purpose">
    @for (purpose of purposes; track purpose) { <nb-option [value]="purpose">{{ 'tracking.trips.' + purpose | translate }}</nb-option> }
  </nb-select>
  <input nbInput fieldSize="small" type="text" inputmode="decimal" [(ngModel)]="draft.rate" [placeholder]="'reimbursementrate.rate' | translate">
  <input nbInput fieldSize="small" type="date" [(ngModel)]="draft.starts_on">
  <button nbButton size="small" status="primary" [disabled]="busy || !valid(draft)" (click)="save(draft)">{{ 'reimbursementrate.add' | translate }}</button>
</div>
